module.exports = __webpack_public_path__ + "img/filter.f4eec202.svg";